import { combineReducers, configureStore } from "@reduxjs/toolkit";
import SpinnersReducer from "./reducers/SpinnersReducer";
import UserReducer from "./reducers/UserReducer";
import LanguageReducer from "./reducers/LanguageReducer";
import TranslationReducer from "./reducers/TranslationReducer";
import MainReducer from "./reducers/MainReducer";

const rootReducer = combineReducers({
	user: UserReducer,
	spinners: SpinnersReducer,
	language: LanguageReducer,
	translation: TranslationReducer,
	main: MainReducer,
});

const index = configureStore({
	reducer: rootReducer,
});

export default index;
